<template>
    <div class="home">
        <Menu :refs.sync="refs" :sub.sync="sub"></Menu>
        <Submenu :sub.sync="sub" :refs.sync="refs"></Submenu>
        <div class="content" :class="{'darker':refs}">
            <Slides v-if="start || slides " class="d-none d-md-block"></Slides>
            <Slidesmobile v-if="start || slides " class=" d-block d-md-none"></Slidesmobile>
            <transition @enter="enterKontakt">
                <Kontakt v-if="kontakt" id="kontakt">
                </Kontakt>
            </transition>
            <Referenz v-if="project[0]" :refs.sync="refs" :project="project[0]" class="referenz"></Referenz>
            <Page v-if="defPage && page" :page="page"></Page>
        </div>
        <div class="reftrigger" @click="toggleRef()" :refs.sync="refs">
            <div class="icon"></div>
        </div>
        <Referenzen :refs.sync="refs">
        </Referenzen>
                    <FootFixed></FootFixed>

    </div>
</template>
<script>
    // @ is an alias to /src
    import Velocity from "velocity-animate";
    import jQuery from "jquery";
    import Referenzen from '@/components/Referenzen.vue'
    import Referenz from '@/components/Referenz.vue'
    import Team from '@/components/Team.vue'
    import Kontakt from '@/components/Kontakt.vue'
    import Start from '@/components/Start.vue'
    import Slides from '@/components/Slides.vue'
    import Slidesmobile from '@/components/mobile/Slides.vue'
    import Page from '@/components/Page.vue'
    import Menu from '@/components/Menu.vue'
    import Submenu from '@/components/Submenu.vue'
    import Foot from '@/components/Footer.vue'
    import FootFixed from '@/components/FootFixed.vue'
    import store from '@/store'

    export default {
        Velocity,
        store,
        name: 'Home',
        components: {
            Start, Referenzen, Referenz, Menu, Foot, FootFixed, Team, Slides, Kontakt, Submenu, Page, Slidesmobile
        },
        data() {
            return {
                refs: this.$route.meta.openRefs,
                ref: this.$route.meta.singleRef,
                startanim: false,
                sub: false
            }
        },
        created() {
            store.dispatch('getInfo')
            store.dispatch('getPages');
        },
        mounted() {
            document.title = this.getTitle();

        },
        watch: {
            '$route.path': function () {
                this.refs = this.openRefs
                this.ref = this.singleRef
                document.title = this.getTitle();
            },
            project() {
                document.title = this.getTitle();
            },
            page() {
                document.title = this.getTitle();
            },
            openRefs() {
                // this.openref?
            }
        },
        computed: {
            openRefs: function () {
                return this.$route.meta.openRefs
            },
            singleRef: function () {
                return this.$route.meta.singleRef
            },
            team: function () {
                return this.$route.meta.team
            },
            kontakt: function () {
                return this.$route.meta.kontakt
            },
            slides: function () {
                return this.$route.meta.slides
            },
            start: function () {
                return this.$route.meta.start
            },
            defPage: function () {
                return this.$route.meta.defPage
            },
            info: () => store.state.info,
            pages: () => store.state.pages,
            projects: () => store.state.projects,
            project: function () {
                return store.state.projects.filter(p => p.slug === this.$route.params.project)
            },
            page: function () {
                return store.state.pages.filter(p => p.slug === this.$route.params.slug)[0]
            },
        },
        methods: {
            getTitle() {
                let prefix = ''
                if (this.singleRef && this.project[0]) {
                    return "Z&Z Arbeiten - " + this.project[0].acf.menubezeichnung
                }
               else if (this.defPage && this.page) {
                    return "Z&Z - " + this.$sanitize(this.page.title.rendered, {allowedTags: []})
                }
               else if (this.kontakt)  {
                   return "Z&Z - Kontakt"
                }
               else if (this.slides)  {
                   return "Z&Z - Über Uns"
                }
                else return "Z&Z Agentur";
            },
            decoder (str) {
                var textArea = document.createElement('textarea');
                textArea.innerHTML = str;
                return textArea.value;
            },
            toggleRef() {
                this.refs = !(this.refs)
            },
            enter(el, done) {
                el.velocity({
                    transform: ['translateX(0)', 'translateX(-150%)']
                }, {
                    duration: 400, complete: function (elements) {
                        jQuery(elements).css("transform", "");
                    }
                })
            },
            subEnter(el, done) {
                el.velocity({
                    transform: ['translateY(0)', 'translateY(-150%)']
                })
            },
            enterKontakt(el, done) {
                let kontakt = el.querySelector('.kontakt');
                let map = el.querySelector('.map');
                kontakt
                    .velocity
                    ({transform: ['translateX(0)', 'translateX(150%)']}, {duration: 500, delay: 300})
                // .velocity
                // ({ opacity: [0, 1]   },{duration: 10000})
                map.velocity({
                        width: ['33%', '100%']
                    }, {duration: 500, delay: 300}
                )
            },
            subLeave(el, done) {
                el.velocity({
                    transform: 'translateY(-150%)'
                })
            },
            leave: function (el, done) {
                el.velocity({
                    transform: ['translateX(-150%)', 'translateX(0)']
                }, {
                    duration: 400,
                    delay: 0
                })
                setTimeout(function () {
                    done();
                }, 2000)
            },
        }
        ,
    }
</script>
<style lang="scss">
    .home {
        background-color: #F2F2F2;

        /*img {*/
        /*    width: 1000px;*/
        /*}*/
    }

    .fullheight {
        min-height: 100vh;
        position: relative;
    }

    .content {
        min-height: 600px;
        transition: filter 1s ease;
        /*filter: brightness(100%);*/
        @include mobile {
            filter: none;
        }
        overflow: hidden;

        &.darker {
            filter: brightness(30%);
        }
    }

    .reftrigger {
        @include mobile {
            display: none;
        }

        &:after {
            content: '';
            background-color: $zzcolor;
            height: 1px;
            position: absolute;
            width: 50px;
            left: 55px;
        }

        position: fixed;
        height: 56px;
        width: 56px;
        top: calc(50% - 28px);
        right: 50px;
        /*background-color: yellow;*/
        border: 1px solid $zzcolor;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: rgba(#ddd, 0.1);

        &:hover {
            background: $zzcolor;
            transition: background-color 0.1s linear;

            .icon {
                background-color: transparent;
                border-color: #F8F8F8;

                &::after {
                    background-color: #fff;
                    transform: translateX(-12px) translateY(12px);
                }

                &::before {
                    background-color: transparent;
                    border-color: #fff;
                    transform: translateX(-6px) translateY(6px);
                }
            }
        }

        .icon {
            width: 16px;
            height: 16px;
            position: relative;
            background-color: rgba(#ddd, 0.2);
            border-radius: 3px;
            z-index: 1;
            border: 1px solid $zzcolor;
            transform: translateX(5px) translateY(-5px);

            &::after {
                transition: all 0.1s linear;
                content: '';
                width: 16px;
                z-index: 0;
                height: 16px;
                background-color: $zzcolor;
                position: absolute;
                left: 0;
                border: 1px solid $zzcolor;
                border-radius: 2px;
                transform: translateX(-10px) translateY(10px);
            }

            &::before {
                transition: all 0.2s ease-out;
                transform: translateX(-5px) translateY(5px);
                content: '';
                width: 16px;
                z-index: 0;
                height: 16px;
                position: absolute;
                left: 0;
                background-color: rgba(#ddd, 0.3);
                border: 1px solid rgba($zzcolor, 0.8);
                border-radius: 2px;
            }
        }
    }
</style>
